import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from '@saastack/router'
import App from './App'
import './polyfills'
import * as serviceWorker from './serviceWorker'

//dynamic generation of manifest.json and appending it to head tag
function injectManifestEarly() {
  const fullPath = window.location.pathname + window.location.search
  const baseUrl = window.location.origin

  const manifest = {
    name: 'Appointy',
    short_name: 'Appointy',
    id: fullPath,
    theme_color: '#1a73e8',
    background_color: '#ffffff',
    display: 'standalone',
    orientation: 'portrait',
    start_url: baseUrl + fullPath, // make it absolute
    icons: [
      {
        src: baseUrl + '/assets/icons/icon-72x72.png', // absolute
        sizes: '72x72',
        type: 'image/png'
      },
      {
        src: baseUrl + '/assets/icons/icon-96x96.png',
        sizes: '96x96',
        type: 'image/png'
      },
      {
        src: baseUrl + '/assets/icons/icon-144x144.png',
        sizes: '144x144',
        type: 'image/png'
      },
      {
        src: baseUrl + '/assets/icons/icon-192x192.png',
        sizes: '192x192',
        type: 'image/png'
      }
    ]
  }

  const blob = new Blob([JSON.stringify(manifest)], { type: 'application/json' })
  const manifestURL = URL.createObjectURL(blob)

  const link = document.createElement('link')
  link.rel = 'manifest'
  link.href = manifestURL
  document.head.appendChild(link)
}

// Inject BEFORE ReactDOM.render
injectManifestEarly()

const rootEl = document.getElementById('root')
ReactDOM.render(
  <BrowserRouter preserveQueryParams>
    <App />
  </BrowserRouter>,
  rootEl
)

serviceWorker.register()